/* eslint-disable lines-between-class-members, class-methods-use-this,react/no-unknown-property */

import Button from '@material-ui/core/Button'
import ButtonBase from '@material-ui/core/ButtonBase'
import Fade from '@material-ui/core/Fade'
import { withStyles } from '@material-ui/core/styles'
import Delete from '@material-ui/icons/Delete'
import cn from 'classnames'
import React, { Component } from 'react'

import theme from '../../utils/theme'
import Avatar from '../Avatar'
import LabelWrapper from '../LabelWrapper'
import spinner from './spinner.svg'

const styles = theme => ({
  button: {
    margin: '0',
    padding: '2px 0',
    minWidth: 'auto',
    minHeight: 'auto',
  },
  input: {
    display: 'none',
  },
  stgLabel: {
    margin: '0  0 8px 0',
    display: 'block',
  },
  stgInlineLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    display: 'inline-block',
    marginBottom: 0,
    textAlign: 'left',
    padding: '10px 2px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  wrapper: {
    '& .MuiAvatar-img': {
      backgroundColor: 'transparent',
    },
    '& .label': {
      marginBottom: '8px',
    },
    '& .withBackground': {
      padding: '14px',
      border: theme.borders.default,
      backgroundColor: `var(--gameday-miscComponents-placeholderAvatarImageBg, ${theme.miscComponents.placeholderAvatarImageBg})`,
      borderRadius: '4px',
      '& .avatar': {
        width: 'auto',
        border: 'none',
        borderRadius: '0',
        justifyContent: 'flex-start',
        backgroundColor: 'transparent !important',
        '& img': {
          width: 'auto',
          textAlign: 'left',
          objectFit: 'contain',
        },
      },
    },
    '& .withBorder .avatar': {
      border: theme.borders.default,
      backgroundColor: `var(--gameday-miscComponents-imagePlaceholderBg, ${theme.miscComponents.imagePlaceholderBg})`,
    },
  },
  deleteImage: {},
  andEdit: {},
  editImage: {},
  isUpload: {},
  avatarWrapper: {
    position: 'relative',
    maxWidth: '200px',
    '& > $deleteImage': {
      position: 'absolute',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
      display: 'flex',
      width: '100%',
      border: 'none',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme.status.errorColor,
      borderRadius: theme.borders.borderRadius,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    '& > $andEdit': {
      bottom: '50%',
      borderRadius: '4px 4px 0 0',
    },
    '& > $editImage': {
      position: 'absolute',
      top: '50%',
      right: '0px',
      bottom: '0px',
      left: '0px',
      display: 'flex',
      width: '100%',
      border: 'none',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme.palette.primary.main,
      borderRadius: '0 0 4px 4px',
    },
    '& > $isUpload': {
      top: '0',
      borderRadius: '4px',
    },
  },
  deleteImageRipple: {
    color: theme.status.errorColor,
  },
  editImageRipple: {
    color: theme.status.successColor,
  },
  deleteIcon: {
    fontSize: '16px',
    color: theme.colors.white,
  },
  deleteText: {
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,
    color: theme.colors.white,
    lineHeight: 1,
  },
  helperText: {
    margin: '8px 0',
    fontSize: '14px',
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
  },
  uploading: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 2px',
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,
    color: theme.palette.primary.main,
  },
  spinner: {
    height: '16px !important',
    marginLeft: '8px',
  },
  sizeError: {
    color: theme.status.errorColor,
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,
  },
  editButton: {
    color: theme.colors.white,
    height: '100%',
    width: '100%',
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  imageUploadDisabled: {
    cursor: 'not-allowed',
  },
})

class ImageUpload extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mouseInside: false,
      sizeError: false,
      hideFailed: false,
    }
  }

  compress = image =>
    new Promise((resolve, reject) => {
      const img = new Image()
      img.src = image
      img.onload = () => {
        const width = 400
        const scaleFactor = width / img.width
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = width
        canvas.height = img.height * scaleFactor
        ctx.drawImage(img, 0, 0, width, img.height * scaleFactor)
        resolve(canvas.toDataURL())
      }
      img.onerror = error => reject(error)
    })

  getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.compress(reader.result)
          .then(result => resolve({ success: true, data: result, file }))
          .catch(e => reject(e))
      }
      reader.onerror = error => reject(error)
    })

  mouseEnter = () => {
    this.setState({ mouseInside: true })
  }
  mouseLeave = () => {
    this.setState({ mouseInside: false })
  }

  render() {
    const {
      avatarName,
      avatarSize,
      avatarSrc,
      backgroundColor,
      defaultImage,
      classes,
      className,
      customCol,
      customMargin,
      customPadding,
      disabled,
      errorText,
      fullWidth,
      helperText,
      id,
      imageTypeLabel,
      isLabelInline,
      isRequired,
      isToolTip,
      isUploading,
      label,
      multipleFields,
      noMobile,
      notWrapper,
      noWrap,
      onChange,
      onDelete,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      withBackground,
      withBorder,
      withDivider,
      useHoverOnly,
      ...rest
    } = this.props

    const { mouseInside, sizeError, fileTypeError, hideFailed } = this.state

    const fileInput = React.createRef()

    return (
      <LabelWrapper
        className={cn(className, classes.wrapper)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        disabled={disabled}
        errorText={errorText}
        fullWidth={fullWidth}
        id={id}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        label={label}
        multipleFields={multipleFields}
        noMobile={noMobile}
        notWrapper={notWrapper}
        noWrap={noWrap}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
        {...rest}
      >
        <div className={disabled ? classes.imageUploadDisabled : classes.imageUpload}>
          <div className={cn({ withBackground, withBorder })}>
            {avatarSrc ? (
              // biome-ignore lint/a11y/noStaticElementInteractions: TODO
              <div className={classes.avatarWrapper} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
                <Avatar
                  shape="square"
                  size={avatarSize}
                  src={avatarSrc}
                  className="avatar"
                  alt={avatarName}
                  name={avatarName}
                  backgroundColor={backgroundColor}
                />
                {onDelete && !disabled && (
                  <Fade in={mouseInside}>
                    <ButtonBase
                      className={cn(classes.deleteImage, {
                        [classes.andEdit]: useHoverOnly,
                      })}
                      onClick={() => {
                        fileInput.current.value = null
                        onDelete()
                      }}
                      TouchRippleProps={{
                        className: classes.deleteImageRipple,
                      }}
                    >
                      {!useHoverOnly && <Delete className={classes.deleteIcon} />}
                      <span className={classes.deleteText}>Delete {!useHoverOnly && 'Image'}</span>
                    </ButtonBase>
                  </Fade>
                )}
                {useHoverOnly &&
                  (disabled ? (
                    // biome-ignore lint/complexity/noUselessFragments: TODO
                    <></>
                  ) : (
                    <Fade in={mouseInside}>
                      <label htmlFor="contained-button-file" className={classes.editImage}>
                        <Button
                          component="span"
                          className={classes.editButton}
                          color="white"
                          TouchRippleProps={{
                            className: classes.editImageRipple,
                          }}
                        >
                          {imageTypeLabel || 'Edit'}
                        </Button>
                      </label>
                    </Fade>
                  ))}
              </div>
            ) : (
              // biome-ignore lint/a11y/noStaticElementInteractions: TODO
              <div className={classes.avatarWrapper} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
                <Avatar
                  shape="square"
                  size={avatarSize}
                  defaultImage={defaultImage}
                  className="avatar"
                  alt={avatarName}
                  name={avatarName}
                  backgroundColor={backgroundColor}
                />
                {useHoverOnly &&
                  (disabled ? (
                    // biome-ignore lint/complexity/noUselessFragments: TODO
                    <></>
                  ) : (
                    <Fade in={mouseInside}>
                      <label htmlFor="contained-button-file" className={cn(classes.editImage, classes.isUpload)}>
                        <Button
                          component="span"
                          className={classes.editButton}
                          color="white"
                          TouchRippleProps={{
                            className: classes.editImageRipple,
                          }}
                        >
                          {avatarSrc ? 'Edit' : imageTypeLabel}
                        </Button>
                      </label>
                    </Fade>
                  ))}
              </div>
            )}
          </div>
          <input
            key={avatarSrc || 'file'}
            accept="image/png, image/jpeg"
            className={classes.input}
            id="contained-button-file"
            multiple
            type="file"
            ref={fileInput}
            onChange={() => {
              if (fileInput.current.files.length > 0) {
                if (fileInput.current.files[0].size >= 5242880) {
                  this.setState({ sizeError: true })
                  setTimeout(() => {
                    this.setState({
                      hideFailed: true,
                    })
                  }, 3000)
                  return
                }
                this.getBase64(fileInput.current.files[0])
                  .then(data => {
                    if (data.file.size < 5242880) {
                      this.setState({ sizeError: false })
                      onChange(data)
                    } else {
                      this.setState({ sizeError: true })
                      setTimeout(() => {
                        this.setState({
                          hideFailed: true,
                        })
                      }, 3000)
                    }
                  })
                  .catch(() => {
                    this.setState({ fileTypeError: true })
                    setTimeout(() => {
                      this.setState({
                        hideFailed: true,
                      })
                    }, 3000)
                  })
              }
            }}
            onDelete={onDelete}
          />
          {helperText && <div className={classes.helperText}>{helperText}</div>}
          {sizeError && !hideFailed && (
            <div className={classes.sizeError}>The image can be no larger than 5MB in size.</div>
          )}
          {fileTypeError && !hideFailed && <div className={classes.sizeError}>The image type is not accepted.</div>}
          {!isUploading ? (
            disabled ? (
              // biome-ignore lint/complexity/noUselessFragments: TODO
              <></>
            ) : (
              !useHoverOnly && (
                <label htmlFor="contained-button-file" className={classes.label}>
                  <Button component="span" className={cn(classes.button, 'edit-button')} color="primary">
                    {imageTypeLabel || 'Edit Image'}
                  </Button>
                </label>
              )
            )
          ) : (
            <span className={classes.uploading}>
              Uploading... <img src={spinner} alt="Loading" className={classes.spinner} />
            </span>
          )}
        </div>
      </LabelWrapper>
    )
  }
}

ImageUpload.defaultProps = {
  avatarSize: 'x-large',
  avatarSrc: null,
  avatarName: '',
  backgroundColor: `var(--gameday-miscComponents-avatarImage, ${theme.miscComponents.avatarImage})`,
  defaultImage: 'profile',
  imageTypeLabel: 'Add Image',
  isLabelInline: false,
  label: '',
  notWrapper: true,
  onChange: () => {},
  required: false,
  toolTipText: 'Recommended image size 200x200 pixels',
  toolTipPosition: 'right',
  withBorder: true,
  useHoverOnly: false,
}

const ImageUploadComponent = withStyles(styles)(ImageUpload)
ImageUploadComponent.displayName = 'ImageUpload'
export default ImageUploadComponent
